import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { formStyles } from '../ClaimCMS1500Form.styles';
import { ClaimTextField } from '../fields';

export const Box26_PatientAccountNo: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">{"26. PATIENT'S ACCOUNT NO."}</Typography>
      <Controller
        name="patientAccountNo"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={field}
            fieldState={fieldState}
            size="small"
            fullWidth
            sx={formStyles.monospaceField}
          />
        )}
      />
    </>
  );
};